import React from "react";
import ProductCard from "../../components/common/ProductCard";
import { useLocation } from "react-router-dom";

const productsData = [
  {
    id: 1,
    title: "Organic Manure",
    subtitle: "(30kg)",
    image: "/assets/productImage/img-10.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannOrganicManure",
  },
  {
    id: 2,
    title: "Utpann Kesari Phos",
    subtitle: "(50kg)",
    image: "/assets/productImage/img-11.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannKesariPhos",
  },
  {
    id: 3,
    title: "Garden Nest",
    subtitle: "(5kg)",
    image: "/assets/productImage/img-12.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannGardenNest",
  },
  {
    id: 4,
    title: "Utpann Plant Booster",
    subtitle: "( 10ltr / 20ltr / 50ltr)",
    image: "/assets/productImage/img-9.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannPlantBooster",
  },
  {
    id: 5,
    title: "Utpann Super",
    subtitle: "(1ltr / 5ltr)",
    image: "/assets/productImage/img-1.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannSuper",
  },
  {
    id: 6,
    title: "Utpann PRO",
    subtitle: "(1ltr)",
    image: "/assets/productImage/img-2.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannPRO",
  },
  {
    id: 7,
    title: "Utpann U-max",
    subtitle: "( 2kg / 4kg / 30kg)",
    image: "/assets/productImage/img-8.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannUMax",
  },
  {
    id: 8,
    title: "Utpann Defensio",
    subtitle: "(1ltr)",
    image: "/assets/productImage/img-3.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannDefensio",
  },
  {
    id: 9,
    title: "Utpann ZSB",
    subtitle: "(500gm)",
    image: "/assets/productImage/img-4.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannZSB",
  },
  {
    id: 10,
    title: "Utpann MYCO",
    subtitle: "(100gm)",
    image: "/assets/productImage/img-5.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannMYCO",
  },
  {
    id: 11,
    title: "Utpann CBC-19",
    subtitle: "(500gm / 1kg)",
    image: "/assets/productImage/img-6.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannCBC-19",
  },
  {
    id: 12,
    title: "Utpann PSF",
    subtitle: "(500gm)",
    image: "/assets/productImage/img-7.png",
    description:
      "Rice straw & husks are abundant agricultural byproducts that offer excellent properties for biochar production.",
    benefits:
      "Increases soil fertility, improves water retention, and carbon sequestration.",
    path: "/UtpannPSF",
  },
  // ... बाकी डेटा यहाँ रखें
];

const ProductsSection = () => {
  const location = useLocation(); // 2. Current path get karein

  // 3. Current path ko productsData ke 'path' se filter karein
  // Agar path match hota hai, toh wo product list se hat jayega
  const filteredProducts = productsData.filter(
    (product) => product.path !== location.pathname,
  );
  return (
    <section className="w-full mt-[51px]">
      <div className="w-full max-w-[1761px] mx-auto px-4 md:px-8 py-[25px] md:py-[37px] lg:py-[50px]">
        <div className="flex flex-col gap-[25px] md:gap-[37px] lg:gap-[50px] items-center">
          <h2 className="text-[40px] sm:text-[75px] xl:text-[100px] font-[parkinsans] font-bold leading-tight text-[#343163] my-[51px]">
            Our Product's
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full">
            {filteredProducts.slice(0, 12).map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
